var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpWhiteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2401 36.4601C29.0044 36.4601 36.9201 28.5445 36.9201 18.7801C36.9201 9.0157 29.0044 1.1001 19.2401 1.1001C9.47566 1.1001 1.56006 9.0157 1.56006 18.7801C1.56006 28.5445 9.47566 36.4601 19.2401 36.4601Z",
    stroke: "#2E63EE",
    fill: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8301 22.08L19.2401 15.49L12.6401 22.08",
    stroke: "#2E63EE",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWhiteFill);
export default __webpack_public_path__ + "static/media/arrow-up-white-fill.2290b327a7ead5534db2e7a5b7f136b1.svg";
export { ForwardRef as ReactComponent };